import JSimg from "../images/JS.png"
import TSimg from "../images/TS.png"
import HTMLimg from "../images/HTML1.png"
import CSSimg from "../images/CSS.png"
import Reactimg from "../images/React1.png"
import Tailwindimg from "../images/Tailwind.png"
import styleimg from "../images/Group.png"

const Stack = () => {
    return(
        <>
        <div className="w-screen h-screen flex flex-col items-center bg-[#F2F2F2] ">
            <h2 className="text-4xl font-bold mt-10">Stack</h2>
            <div className=" flex flex-row justify-around mt-20 w-[80vw]">
                <div className="w-[25vw] h-[60vh] bg-white shadow-md rounded-xl flex flex-col items-center">
                    <h3 className="text-4xl font-bold mt-8">Language</h3>
                    <div className="w-[23vw] mt-8 flex flex-col items-center border-t-[1px] border-solid border-black">
                        <div className="text-xl font-bold mt-8 flex flex-row items-center w-[10vw]">
                            <img className="w-[3vh] h-[3vh] rounded-md" src={JSimg} alt="자바스크립트이미지"></img>
                            <span className="ml-4">Javascript</span>
                        </div>
                        <div className="text-xl font-bold mt-4 flex flex-row items-center w-[10vw]">
                            <img className="w-[3vh] h-[3vh] rounded-md" src={TSimg} alt="타입스크립트이미지"></img>
                            <span className="ml-4">Typescript</span>
                        </div>
                        <div className="text-xl font-bold mt-4 flex flex-row items-center w-[10vw]">
                            <img className="w-[3vh] h-[3vh] rounded-md" src={HTMLimg} alt="HTML이미지"></img>
                            <span className="ml-4">HTML</span>
                        </div>
                        <div className="text-xl font-bold mt-4 flex flex-row items-center w-[10vw]">
                            <img className="w-[3vh] h-[3vh] rounded-md" src={CSSimg} alt="CSS이미지"></img>
                            <span className="ml-4">CSS</span>
                        </div>
                    </div>
                </div>
                <div className="w-[25vw] h-[60vh] bg-white shadow-md rounded-xl flex flex-col items-center">
                    <h3 className="text-4xl font-bold mt-8">Framework</h3>
                    <div className="w-[23vw] mt-8 flex flex-col items-center border-t-[1px] border-solid border-black">
                    <div className="text-xl font-bold mt-8 flex flex-row items-center w-[10vw]">
                            <img className="w-[3vh] h-[3vh] rounded-md" src={Reactimg} alt="React이미지"></img>
                            <span className="ml-4">React</span>
                        </div>
                    </div>
                </div>
                <div className="w-[25vw] h-[60vh] bg-white shadow-md rounded-xl flex flex-col items-center">
                    <h3 className="text-4xl font-bold mt-8">Style</h3>
                    <div className="w-[23vw] mt-8 flex flex-col items-center border-t-[1px] border-solid border-black">
                    <div className="text-xl font-bold mt-8 flex flex-row items-center w-[10vw]">
                            <img className="w-[3vh] h-[3vh] rounded-md" src={Tailwindimg} alt="Tailwindcss이미지"></img>
                            <span className="ml-4">TailwindCSS</span>
                        </div>
                        <div className="text-xl font-bold mt-4 flex flex-row items-center w-[10vw]">
                            <img className="w-[3vh] h-[3vh] rounded-md" src={styleimg} alt="CSS이미지"></img>
                            <span className="ml-4">Styled components</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Stack;